import { CONFIG } from './config';

let mode;

switch (CONFIG.mode.enableType) {
  case 'mobile':
    mode = 'IN';
    break;
  case 'not_client':
    mode = 'WEB';
    break;
  case 'not_client_executive':
    mode = 'WEB-PF';
    break;
  case 'client':
    mode = 'IN';
    break;
  case 'executive':
    mode = 'PF';
    break;
}

export const environment = {
  hybridModel: true,
  isQa: true,
  mode,
  isStubby: false,
  isLocal: false,
  isWc: CONFIG.mode.isWC,
  isMobile: CONFIG.mode.isMobile,
  should_encrypt: true,
  production: false,
  accountNormalize: CONFIG.accountNormalize,
  local: false,
  contentful: {
    space: CONFIG.secrets.CONTENTFUL_SPACE_PREPROD,
    accessToken: CONFIG.secrets.CONTENTFUL_ACCESS_TOKEN_PREPROD,
    host: 'preview.contentful.com'
  },
  bankingServer: {
  base_path: {
      omni1: '/bankingserver-api-falabella-web',
      omni2: '/bankingserver-api-falabella'
    },
  oauth2Endpoint: '/oauth/token',
  concurrencyCheck: '/rest/resources/concurrency/',
  pubKey: CONFIG.secrets.BANKING_SERVER_PUBKEY_QA,
  clientId: 'client-web',
  clientSecret: 'falabella1234',
  keepAliveEndpoint: 'keepAlive',
  sessionExpirationDelta: 15
  },
  accountOpeningParams: {
    commerce: 'Banco',
    channel: mode,
    country: 'PE',
    allowedAccountTypes: ['sueldo', 'ahorro', 'cts', 'ahorrosueldo'],
    allowedUrlAccountTypes: ['ahorro-falabella', 'ahorro-clasica', 'ahorro-sueldo']
  },
  pepParams: {
    url: '/api/pep/',
    isClient: chargeModePEP()
  },
  vuParams: {
    vuUrl:  '/api/vu-second-factor/',
    country: 'PE',
    commerce: 'Banco'
 },
  vuPubKey: CONFIG.secrets.VU_PUB_KEY_QA,
  pubKey: CONFIG.secrets.PUB_KEY_QA,
  bsPubKey: CONFIG.secrets.BANKING_SERVER_PUBKEY_QA,
  REFRESH_URL: {
    DEVICE: '/api/vu-second-factor/device',
    OMNI2: 'https://plataforma2-qa.bancofalabella.pe',
    OMNI1: 'https://web2-qa.bancofalabella.pe'
  },
  SERVICES: {
    HOST: 'https://banco-pe-onboarding-productos-qa.fif.tech',
    HOST_PRIVATE: 'https://banco-pe-onboarding-productos-qa-priv.fif.tech',
    BASE_PATH: '/api/ingress/onboarding/',
    CAE: {
      URI: 'evaluate/v1/clientAdmissionEvaluate'
    },
    EMAIL_VALIDATE: {
      URI: 'client/v1/emailageValidate'
    },
    IS_CTS_EMPLOYEE: {
      URI: 'client/v1/empleadoCTSColaboradoresObtener'
    },
    PASSIVE_DOCUMENT_CREATION: {
      URI: 'client/v1/passiveDocumentCreation'
    },
    REQUEST_MANAGER_GET: {
      URI: 'application/v1/getRequestManager'
    },
    REQUEST_MANAGER_CREATE: {
      URI: 'application/v1/createRequestManager'
    },
    ADDRESS_MANAGER_CREATE: {
      URI: 'application/v1/addressRequestManager'
    },
    LABOR_MANAGER_CREATE: {
      URI: 'application/v1/laborRequestManager'
    },
    NATIONALITY_MANAGER_CREATE: {
      URI: 'application/v1/nationalityRequestManager'
    },
    CONFIG_REQUEST_MANAGER: {
      URI: 'application/v1/configRequestManager'
    },
    FINANCIAL_DATA_MANAGER_CREATE: {
      URI: 'application/v1/financialDataRequestManager'
    },
    TERMS_AND_CONDITIONS_MANAGER_CREATE: {
      URI: 'application/v1/termsRequestManager'
    },
    CUSTOMER_CHALLENGE_GENERATE: {
      URI: 'client/v1/clienteDesafioGenerar'
    },
    CHECK_TOKEN: {
      URI: 'account/v1/checkToken'
    },
    PASSWORD_CREATE: {
      URI: 'account/v1/passwordCreation'
    },
    CREATE_USER_ACCOUNT: {
      URI: 'client/v1/createUserAccount'
    },
    CREATE_USER_ACCOUNT_PRIVATE: {
      URI: 'private/v1/createUserAccount'
    },
    CIGO: {
      URI: 'client/v1/clientGeneralInformation'
    },
    COG: {
      URI: 'client/v1/cuentaOtorgamientoGenerar'
    },
    COG_PRIVATE: {
      URI: 'private/v1/cuentaOtorgamientoGenerar'
    },
    PIO: {
      URI: 'client/v1/personInformationGet'
    },
    CLIENT_STATE_PASSWORD_GET: {
      URI: 'client/v1/clientStatePasswordGet'
    },
    DOCUMENT_SIGNATURE: {
      URI: 'document-signature/v1/documentSignature'
    },
    DOCUMENT_SIGNATURE_PRIVATE: {
      URI: 'private/v1/documentSignature'
    },
    TRI: {
      URI: 'fraud/v1/transactionRiskStart'
    },
    TRE: {
      URI: 'fraud/v1/transactionRiskEvaluate'
    },
    VALIDATE_SESSION: {
      URI: 'fast-track/v1/validateSession'
    },
    FACE_ID_APPLICATION: {
      URI: '/onboarding/cross/match-on-card/v2/application'
    },
    FACE_ID_VERIFICATION: {
      URI: '/onboarding/cross/match-on-card/v2/verification'
    },
    CAPI: '/onboarding/cross/capi/v1/account',
    PARTIAL_ATTEMPT: '/onboarding/cross/match-on-card/v2/partial-attempt',
    ZYTRUST_HOST: 'https://poc.zytrust.com'
  },
  staticScripts: {
    fingerprint: 'https://static-qa.fif.tech/omnichannel-assets/bfpe/scripts/onboarding/fingerprint2.js',
    uuid: 'https://static-qa.fif.tech/omnichannel-assets/bfpe/scripts/onboarding/uuidv4.js',
    vubrowser: 'https://static-qa.fif.tech/omnichannel-assets/bfpe/scripts/onboarding/vubrowserfp.js',
    facialID: 'https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/scripts/bundle-facial-0.1.1.js',
    staticAssets: 'https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/'
  },
  GA_ENV: 'qa',
  flagr: {
    url: 'https://flagr-qa.fif.tech/api/flag/evaluation/v1/single',
    pubKey: '-----BEGIN PUBLIC KEY-----' +
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApkALLhocuyoPO/MgvnsF' +
      'mBcX+z0HYoSQnLKS9E+J3LaVOlLhgQRBs5Ygr/1mFXArtKuIMimDG8GCi9r8YdYn' +
      't57FzBZD4ddICmFVsbQJmmWrJVoF7t6DFMzK4EKP5KXJ3b2PDdKP7WTi4ecJDry5' +
      'GTHE/CCk/AxeRDdSYCYwDCoMmzgCcpqouQxcgJ2LUWQdENjDq+jzHzOdm2v56chO' +
      '4HpeBBIYLYr+ZwBfHQj8LgpdxDDxw8nsfRBgaebTK2jQrAiiYaqjy0tHrrpxxtQL' +
      'bagRDji2kIfeuAleLHaX2fZXw3PlI8KiWRd36XDn4kkfnz5XL8Zvk71nV3XIiEIv' +
      'XwIDAQAB' +
      '-----END PUBLIC KEY-----',
    flagKey: 'rout_pe_onboarding_cuentas_faceid'
  },
  datadog: {
    clientToken: 'pub1edc5824b0212d7224371a5b6185ef33',
    aplicationId: 'cb04a10f-b518-4fbf-911c-bf873a597cdd',
    site: 'datadoghq.com',
    service: 'banco-pe-onboarding-cuentas-preprod'
  }
};

function chargeModePEP() {
  let isClient = false;
  if (CONFIG.mode.enableType === 'client') {
    isClient = true;
  } else if (CONFIG.mode.enableType === 'executive'  || CONFIG.mode.enableType === 'not_client_executive') {
    isClient = false;
  } else  {
    isClient = false;
  }
  return isClient;
}
